<template>
  <div :data-test-key="name + '-paging'" class="text-xs-center">
    <div class="d-inline-flex">
      <luci-btn-icon v-if="showFirst" :config="first" @callback="$emit('page', 'first')"></luci-btn-icon>
      <luci-btn-icon v-if="showPrevious" :config="previous" @callback="$emit('page', 'previous')"></luci-btn-icon>
      <luci-btn-icon v-if="showNext" :config="next" @callback="$emit('page', 'next')"></luci-btn-icon>
      <luci-btn-icon v-if="showLast" :config="last" @callback="$emit('page', 'last')"></luci-btn-icon>
    </div>
  </div>
</template>

<script>
import { has, includes, split } from 'lodash'

export default {
  name: 'Paging',
  props: {
    name: String,
    view: { type: Object, default: () => {} }
  },
  data () {
    return {
      first: { type: 'button', icon: true, navigation: true, name: 'btn-first', tooltip: 'First page', iconType: 'first_page' },
      previous: { type: 'button', icon: true, navigation: true, name: 'btn-previous', tooltip: 'Previous page', iconType: 'navigate_before' },
      next: { type: 'button', icon: true, navigation: true, name: 'btn-next', tooltip: 'Next page', iconType: 'navigate_next' },
      last: { type: 'button', icon: true, navigation: true, name: 'btn-last', tooltip: 'Last page', iconType: 'last_page' }
    }
  },
  computed: {
    showFirst () {
      if (has(this.view, '@id')) {
        const curPageNumber = split(this.view['@id'], 'page=')[1]
        const curPageIsFirstPage = includes(this.view['hydra:first'], `page=${curPageNumber}`)
        return has(this.view, 'hydra:first') && !curPageIsFirstPage
      }
      return false
    },
    showPrevious () {
      if (this.view) {
        return has(this.view, 'hydra:previous')
      }
      return false
    },
    showNext () {
      if (this.view) {
        return has(this.view, 'hydra:next')
      }
      return false
    },
    showLast () {
      if (has(this.view, '@id')) {
        const curPageNumber = split(this.view['@id'], 'page=')[1]
        const curPageIsLastPage = includes(this.view['hydra:last'], `page=${curPageNumber}`)
        return has(this.view, 'hydra:last') && !curPageIsLastPage
      }
      return false
    }
  }
}
</script>
